import { BASE_SERVICE_URL } from '../lib/constants'

export default function getDatabaseHeaders(eventType) {
    return fetch(BASE_SERVICE_URL + `/models/${eventType}/`, {
        credentials: 'same-origin'
    }).then(response => {
        if (response.ok) {
            return response.json()
            // return response
        } else {
            const error = new Error(response.statusText)
            error.response = response
            throw error
        }
    })
}
